<template>
  <div class="my-published-videos-area">
    <List :totalCount="totalCount" @flipPage="flipPage">
      <template v-slot:listContent>
        <div v-show="booksCurrentSubAccount == ''" class="add-block card" @click="addVideo">
          <img src="@imgs/add-book.png" alt="" />
          <div>上传视频</div>
        </div>
        <div class="card normal" v-for="(item, index) in videos" v-bind:key="item.id">
          <img :src="item.coverUrl || require('@imgs/default_video_cover.png')" alt="" />
          <div class="get-book" @click="previewVideo(item.id)"></div>
          <div class="info-and-deal" v-show="!item.isReplacing">
            <div class="title">{{ item.shareTitle }}</div>
            <div>{{ item.time }}</div>
            <div class="deal-btn-wrapper">
              <el-tooltip class="item" v-show="booksCurrentSubAccount == ''" effect="dark" content="编辑" placement="bottom" v-if="item.readModel != 1">
                <img class="icon-style" src="@imgs/compile.png" @click="editHandler(item.id)" />
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="分享" placement="bottom">
                <img class="icon-style" src="@imgs/share-icon.png" @click="shareHandler(item.id, item.shareTitle)" />
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
                <img class="icon-style" src="@imgs/delete-icon.png" @click="deleteHandler(item.fileId)" />
              </el-tooltip>
            </div>
          </div>
          <img
            class="qr-hover-button"
            v-show="!item.isReplacing && item.transitionStatus === 1"
            @mouseenter="currentHoverIndex = index"
            @mouseleave="currentHoverIndex = -1"
            src="@imgs/bookshelf/bookshelf_qrcode.png"
          />
        </div>
      </template>
    </List>
    <Setting v-if="settingVisible" :id="settingId" :settingVisible="settingVisible" @updateVisible="updateSettingVisible" @settingSuccess="settingSuccess"></Setting>
    <TipDialog ref="deleteDialog" :dialogOptions="deleteDialogOptions" @clickCancel="deleteVideoCancel" @clickConfirm="deleteConfirm"></TipDialog>
    <ShareDilalog ref="shareVideo" :qrObj="qrObj" :isInset="isInset" typeName="视频" />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import moment from 'moment'
import { getVideoList, deleteVideo } from '@api/video'
import ShareDilalog from '@/components/MyBookshelf/components/ShareDialog'
import TipDialog from '@components/common/TipDialog.vue'
import List from '@components/list/listFrame'
import Setting from './setting.vue'

export default {
  name: 'Published',
  data() {
    return {
      settingVisible: false,
      flag: false,
      listOptions: {
        addBlockTitle: '上传视频'
      },
      qrObj: {
        value: '',
        iframeUrl: '',
        isShowPoster: 0
      },
      isInset: true, //是否显示分享书刊嵌入代码
      currentHoverIndex: -1,
      replaceId: -1,
      currentPageNo: 1,
      scrollFlag: true,
      deleteId: -1,
      totalCount: 0,
      videos: [],
      editDialogVisible: false, // 流式编辑窗口可见
      deleteDialogOptions: {
        // 弹框类型
        type: 'delete',
        // 弹框头部标题
        title: '提示',
        // 弹框内容
        tip: '作品删除后无法恢复，是否确认删除？'
      },
      settingId: -1,
      queryTitle: '',
      searchData: {
        queryTitle: '',
        createTimeEnd: '',
        createTimeStart: ''
      }
    }
  },
  components: {
    ShareDilalog,
    TipDialog,
    List,
    Setting
  },
  computed: {
    ...mapState('manage', ['booksCurrentSubAccount']),
    bookListPages() {
      return this.$store.state.manage.bookListPages
    },
    userName() {
      return this.$store.getters['common/userName']
    }
  },
  methods: {
    //翻页
    flipPage(val) {
      this.getVideos(val)
      this.currentPageNo = val
    },
    // 获取视频列表
    getVideos(pageNo) {
      const param = {
        pageNo: pageNo,
        pageSize: 11,
        userName: this.booksCurrentSubAccount !== '' ? this.booksCurrentSubAccount : this.userName,
        title: this.searchData.queryTitle,
        createTimeStart: this.searchData.createTimeStart,
        createTimeEnd: this.searchData.createTimeEnd
      }
      getVideoList(param).then((res) => {
        if (res && res.status == 200 && res.data.page) {
          if (res.data.page.result.length) {
            this.videos = res.data.page.result.map((item, index) => {
              return {
                ...item,
                time: moment(item.createTime).format('YYYY-MM-DD HH:mm')
              }
            })
          } else {
            this.videos = []
          }
          this.totalCount = res.data.page.totalCount
        }
      })
    },
    // 跳转上传视频页面
    addVideo() {
      this.$router.push({ name: 'Upload', params: { to: 'VideoUpload' } })
    },
    editHandler(id) {
      this.flag = true
      this.settingVisible = true
      this.settingId = id
    },
    // 更改修改弹窗展示状态
    updateSettingVisible(visible) {
      this.settingVisible = visible
    },
    settingSuccess() {
      this.getVideos(this.currentPageNo)
    },
    //预览视频
    previewVideo(id) {
      const routerUrl = this.$router.resolve({
        path: '/video',
        query: { id: id }
      })
      window.open(routerUrl.href, '_blank')
    },
    //---------删除---------
    deleteHandler(id) {
      this.$refs.deleteDialog.visible = true
      this.deleteId = id
    },
    shareHandler(id, title) {
      this.$refs.shareVideo.dialogVisible = true
      const routeUrl = this.$router.resolve({
        path: '/video',
        query: { id: id }
      })
      const url = window.location.origin + routeUrl.href
      this.qrObj.title = title
      this.qrObj.value = url
      this.qrObj.iframeUrl = '<iframe src="' + this.qrObj.value + '" style="width:100%;height:99.5%"></iframe>'
    },
    editDialogCancel() {
      this.editDialogVisible = false
    },
    editDialogConfirm() {
      this.editDialogVisible = false
    },
    deleteVideoCancel() {
      this.$refs.deleteDialog.visible = false
    },
    deleteConfirm() {
      this.$refs.deleteDialog.visible = false
      let params = {
        fileId: this.deleteId
      }
      deleteVideo(params).then((res) => {
        if (res.status == 200) {
          if (res.data) {
            this.$alert(res.data.msg, '提示', {
              confirmButtonText: '确定'
            })
            if (this.videos.length === 1 && this.currentPageNo > 1) {
              this.currentPageNo--
            }
            this.getVideos(this.currentPageNo)
            this.getSpace()
          }
        }
      })
    },
    // 已用容量
    getSpace() {
      this.$store.dispatch('manage/getSpace')
    }
  },
  watch: {
    booksCurrentSubAccount() {
      this.getVideos(1)
    }
  },
  mounted() {
    this.getVideos(1)
  }
}
</script>

<style lang="scss">
.my-published-videos-area {
  .card {
    display: inline-block;
    vertical-align: top;
    width: 249px;
    height: 340px;
    border: 1px solid rgba(232, 232, 232, 1);
    color: rgba(255, 255, 255, 0.8);
    margin-right: 10px;
    margin-bottom: 10px;
    position: relative;
    color: #fff;
    line-height: 20px;
    cursor: pointer;
    .shade {
      position: absolute;
      width: 100%;
      height: 100%;
      font-size: 14px;
      background: rgba(0, 0, 0, 0.5);
      top: 0;
      left: 0;
      cursor: default;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    }
    .get-book {
      height: 280px;
      width: 100%;
      position: absolute;
    }
    .info-and-deal {
      display: none;
      position: absolute;
      width: 100%;
      height: 80px;
      background: rgba(0, 0, 0, 0.5);
      bottom: 0;
      left: 0;
      padding: 2px 10px;
      line-height: 21px;
      font-size: 14px;
      .title {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .qr-hover {
      background: rgba(0, 0, 0, 0.5);
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
    }
    .qr-hover-button {
      position: absolute;
      left: 21px;
      top: 21px;
    }
    .transfer {
      background: rgba(0, 0, 0, 0.5);
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      padding: 0 30px;
    }
    .deal-btn-wrapper {
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      .deal-btn {
        display: inline-block;
        padding: 5px 0px;
        width: 30%;
        text-align: center;
        border-radius: 6px;
        background: rgba(81, 81, 81, 1);
        margin-right: 6px;
        &.replace {
          position: relative;
          .upload {
            width: 100%;
            height: 100%;
            min-height: 100%;
            position: absolute;
            top: 0;
            opacity: 0;
          }
        }
      }
      .replace {
        position: relative;
        .upload {
          width: 100%;
          height: 100%;
          min-height: 100%;
          position: absolute;
          top: 0;
          opacity: 0;
        }
      }
      .deals-btn {
        width: 25%;
        height: 30px;
        font-size: 14px;
      }
      .bg-yellow {
        background: rgba(223, 88, 19, 1);
      }
      .icon-style {
        width: 20px;
        height: 20px;
        display: block;
        position: static;
        top: 0;
        left: 0;
        transform: none;
      }
    }
  }
  .card:hover .info-and-deal {
    display: block;
  }
  .page-component {
    position: fixed;
    background-color: #fff;
    width: calc(100% - 265px);
    bottom: 20px;
    right: 20px;
    left: 245px;
  }
  .normal img {
    max-width: 100%;
    max-height: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .add-block {
    color: #000;
    padding: 150px 20px;
    text-align: center;
    img {
      margin-bottom: 16px;
    }
  }
  .edit-dialog {
    .el-dialog__body {
      padding: 25px 75px;
    }
  }
}
</style>
